import { Text } from 'spectacle';

Text.defaultProps = {
  ...Text.defaultProps,
  textColor: 'secondary',
};
export default Text;
